<template>
	<div class="ad-wrap">
		<div v-if="show" ref="placementEl" :class="classes"></div>
	</div>
</template>

<script>
export default {
	props: {
		placementName: {
			type: String,
			required: true
		},
		classes: {
			type: String
		}
	},
	data() {
		return {
			placement: null
		};
	},
	computed: {
		show() {
			const user = this.$store.state.auth.user;
			// Show for guests
			if (!user.id) {
				return true;
			}

			// Hide for mods
			if (user.moderatorRoles && user.moderatorRoles.length > 0) {
				return false;
			}

			// Hide for non-donators and T1 donators
			return user.donatorTier < 2;
		}
	},
	mounted() {
		const placementRef = this.$refs.placementEl;
		self.__VM.push((_adManager, scope) => {
			console.log("[PROSPER] mounted", this.placementName);
			if (this.placementName === "vertical_sticky") {
				scope.Config.verticalSticky().display();
			} else if (
				this.placementName === "horizontal_sticky" ||
				this.placementName === "mobile_horizontal_sticky" ||
				this.placementName === "video_slider"
			) {
				this.placement = scope.Config.get(this.placementName).displayBody();
			} else {
				this.placement = scope.Config.get(this.placementName).display(placementRef);
			}
		});
	},
	destroyed() {
		self.__VM.push((_adManager, scope) => {
			console.log("[PROSPER] removed", this.placementName);
			if (this.placementName === "vertical_sticky") {
				scope.Config.verticalSticky().destroy();
			} else {
				this.placement.remove();
			}
		});
	}
};
</script>

<style lang="scss" scoped>
.ad-wrap {
	width: 100%;
	display: flex;
	justify-content: center;
	margin: 2rem 0;
}
</style>
